export const environment = {
  production: true,
  urlAPI: 'https://api.stihl-local.pt/api/',
  urlApiVideos: 'https://api.stihl-local.pt/api/Video/GetRangedVideos/',
  urlWeb: 'https://www.stihl-local.pt/',
  blobPublic: 'https://blobstihlportugal.blob.core.windows.net/prod-stihl-pt-public/',
  authority: 'https://stihl-sso.com/auth/oauth2/consumer/',
  clientId: 'stihl_local_pt',
  useSSO: true,
  IdEventoMarca: 'XnoLzShvi2xdEqIte2rGQg==',
  IdGaleriaMulti: 'dclveeRhDBsCKrMxip7mqg==',
  IdForoRrss: 'bHvkRhT6fk_gnNEF$PBaxA%3D%3D'
};
